import L from "leaflet";

enum ScreenSize {
    mobile,
    tablet,
    laptop,
    desktop,
    tv
}

export default function getParam(screenSize) {

    let parameters: any = {};
    parameters.centerFromUrl = [0, 0];
    
    if (window.location.href.indexOf("") !== -1) {
        parameters.centerFromUrl = [55.490759, 9.474450];
        var southWest = L.latLng(55.477858, 9.438271);
        var northEast = L.latLng(55.509734, 9.507637);

        if (screenSize === ScreenSize.mobile) { parameters.zoomFromUrl = 15; }
        else if (screenSize === ScreenSize.tablet) { parameters.zoomFromUrl = 15.5; }
        else if (screenSize === ScreenSize.laptop) { parameters.zoomFromUrl = 16; }
        else if (screenSize === ScreenSize.desktop) { parameters.zoomFromUrl = 16; }
        else if (screenSize === ScreenSize.tv) { parameters.zoomFromUrl = 16; }
        else { parameters.zoomFromUrl = 16; }
        parameters.maxZoom = 22;
        parameters.minZoom = 15;
        parameters.boundsFromUrl = L.latLngBounds(southWest, northEast);
    }

    return (parameters)
}
